module.exports = __webpack_public_path__ + "static/media/ms-symbollockup_mssymbol_19.319d9b9a.svg";